import { Link, NavLink } from "react-router-dom";
import logo from "../images/Menu-Charter-Logo.png";
import { MdLogout, MdSettings } from "react-icons/md";
import { FaTimes, FaUserGraduate, FaUsers } from "react-icons/fa";
import { SiPlaycanvas, SiSessionize } from "react-icons/si";
import { BsClockFill } from "react-icons/bs";
import { useState } from "react";
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { PiUserSquareBold, PiBook, PiFileText } from "react-icons/pi";
const SideMenu = (props) => {
  const [settingsClicked, setSettingsClicked] = useState(false);

  const Logout = () => {
    localStorage.clear();
    localStorage.clear();
    window.location = "/Login";
    window.location.reload();
  };

  return (
    <>
      <aside>
        <ul>
          <li className="logo">
            <img
              src={logo}
              alt="CTS Logo"
              onClick={() => {
                setSettingsClicked(false);
                props.setClosed(true);
              }}
              className="d-none d-md-block"
            />
            <span
              className="d-md-none close-menu"
              onClick={() => props.setClosed(true)}
            >
              <FaTimes />
            </span>
          </li>
          {props.userPermissions.viewDashboard && (
            <li
              onClick={() => {
                setSettingsClicked(false);
                props.setClosed(true);
              }}
            >
              <NavLink to={"/Dashboard"}>
                <span className="icon">
                  <BsClockFill />
                </span>
                <span>Dashboard</span>
              </NavLink>
            </li>
          )}
          {props.userPermissions.viewStudents && (
            <li
              onClick={() => {
                setSettingsClicked(false);
                props.setClosed(true);
              }}
            >
              <NavLink to={"/Students"}>
                <span className="icon">
                  <FaUsers />
                </span>
                <span>Students</span>
              </NavLink>
            </li>
          )}
          {props.userPermissions.viewTeachers && (
            <li
              onClick={() => {
                setSettingsClicked(false);
                props.setClosed(true);
              }}
            >
              <NavLink to={"/Teachers"}>
                <span className="icon">
                  <FaUsers />
                </span>
                <span>Teachers</span>
              </NavLink>
            </li>
          )}
          {props.userPermissions.viewCourses && (
            <li
              onClick={() => {
                setSettingsClicked(false);
                props.setClosed(true);
              }}
            >
              <NavLink to={"/Courses"}>
                <span className="icon">
                  <SiPlaycanvas />
                </span>
                <span>Courses</span>
              </NavLink>
            </li>
          )}

          {props.userPermissions.viewGradeBook &&
            props.userPermissions.viewGradeBook && (
              <li
                onClick={() => {
                  setSettingsClicked(false);
                  props.setClosed(true);
                }}
              >
                <NavLink to={"/gradebook"}>
                  <span className="icon">
                    <PiBook />
                  </span>
                  <span>Gradebook</span>
                </NavLink>
              </li>
            )}

          {props.userPermissions.teacherCompliance &&
            props.userPermissions.teacherCompliance && (
              <li
                onClick={() => {
                  setSettingsClicked(false);
                  props.setClosed(true);
                }}
              >
                <NavLink to={"/reports"}>
                  <span className="icon">
                    <PiFileText />
                  </span>
                  <span>Reports</span>
                </NavLink>
              </li>
            )}

          {props.userPermissions.deleteSessions && (
            <li
              onClick={() => {
                setSettingsClicked(false);
                props.setClosed(true);
              }}
            >
              <NavLink to={"/Sessions/DeleteSessions"}>
                <span className="icon">
                  <SiSessionize />
                </span>
                <span>Sessions</span>
              </NavLink>
            </li>
          )}
          {props.userPermissions.viewSettings && (
            <>
              <li
                className="settings-menu-item"
                onClick={() => setSettingsClicked(true)}
              >
                <a className={settingsClicked ? "active" : ""}>
                  <span className="icon">
                    <MdSettings />
                  </span>
                  <span>Settings</span>
                  {settingsClicked && (
                    <ul>
                      {(props.userPermissions.viewOperators ||
                        props.userPermissions.viewSchools ||
                        props.userPermissions.viewDashboardVariables) && (
                        <>
                          <li>
                            <h4>Operators & Schools</h4>
                          </li>
                          {props.userPermissions.viewOperators && (
                            <li>
                              <NavLink to={"/Settings/Operators"}>
                                <span className="icon">
                                  <FaUserGraduate />
                                </span>
                                <span>Operators</span>
                              </NavLink>
                            </li>
                          )}
                          {props.userPermissions.viewSchools && (
                            <li>
                              <NavLink to={"/Settings/Canvas/Sub_Accounts"}>
                                <span className="icon">
                                  <HiOutlineBuildingLibrary />
                                </span>
                                <span>Schools</span>
                              </NavLink>
                            </li>
                          )}
                          {/* {props.userPermissions.viewDashboardVariables && (
                            <li>
                              <NavLink to={"/Settings/Variables"}>
                                <span className="icon">
                                  <HiOutlineBuildingLibrary />
                                </span>
                                <span>Dashboard Variables</span>
                              </NavLink>
                            </li>
                          )} */}
                        </>
                      )}
                      {(props.userPermissions.viewUsers ||
                        props.userPermissions.viewRoles) && (
                        <>
                          <li>
                            <h4>Users Configurations</h4>
                          </li>
                          {props.userPermissions.viewUsers && (
                            <li>
                              <NavLink to={"/Settings/UsersList"}>
                                <span className="icon">
                                  <PiUserSquareBold />
                                </span>
                                <span>Users</span>
                              </NavLink>
                            </li>
                          )}
                          {props.userPermissions.viewRoles && (
                            <li>
                              <NavLink to={"/Settings/Roles"}>
                                <span className="icon">
                                  <PiUserSquareBold />
                                </span>
                                <span>Roles & Permissions</span>
                              </NavLink>
                            </li>
                          )}
                        </>
                      )}

                      <li>
                        <h4>Data Sync Configurations</h4>
                      </li>
                      <li>
                        <NavLink to={"/Settings/DataSync"}>
                          <span className="icon">
                            <PiUserSquareBold />
                          </span>
                          <span>Data Sync</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/Settings/DataSync/Terms"}>
                          <span className="icon">
                            <PiUserSquareBold />
                          </span>
                          <span>Terms</span>
                        </NavLink>
                      </li>
                      {/* <li>
                        <NavLink to={"/Settings/DataSync/Accounts"}>
                          <span className="icon">
                            <PiUserSquareBold />
                          </span>
                          <span>Accounts</span>
                        </NavLink>
                      </li> */}
                      {/* <li>
                        <NavLink to={"/Settings/DataSync/Courses"}>
                          <span className="icon">
                            <PiUserSquareBold />
                          </span>
                          <span>Courses</span>
                        </NavLink>
                      </li> */}
                      {/* <li>
                        <NavLink to={"/Settings/DataSync/CanvasUser"}>
                          <span className="icon">
                            <PiUserSquareBold />
                          </span>
                          <span>Users</span>
                        </NavLink>
                      </li> */}
                    </ul>
                  )}
                </a>
              </li>
            </>
          )}

          {/* <li className="logout">
            <Link onClick={() => Logout()}>
              <span className="icon">
                <MdLogout />
              </span>
              <span>Change Password</span>
            </Link>
          </li> */}
          <li className="logout">
            <Link onClick={() => Logout()}>
              <span className="icon">
                <MdLogout />
              </span>
              <span>Log Out</span>
            </Link>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default SideMenu;
